export var RankingConstants = {
    CoopPositionByNameUrl: "/highscore/coop/experience/positionByName/{coopName}?&language={language}",
    CoopPositionUrl: "/highscore/coop/experience?position={position}&pageSize={pageSize}&language={language}",
    LeagueDivisions: 3,
    NumberCoopDivisions: 3,
    NumberPlayerLeagueDivisions: 3,
    PageSize: 10,
    PlayerPositionByNameUrl: "/highscore/player/experience/positionByName/{playerName}?&language={language}",
    PlayerPositionUrl: "/highscore/player/experience?position={position}&pageSize={pageSize}&language={language}",
    UseWebSize: true,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/RankingConstants.ts
// module id = 422
// module chunks = 3